/* eslint-disable */
const release = {
  "RELEASE_NOTES": "Release notes and information",
  "ALL_RELEASE_DISPLAYED": "All available information is displayed",
  "ALL_RELEASE_NOTES": "Shizen updates",
  "LATEST_ESSENTIAL_FEATURES": "Latest essential features",
  "ESSENTIAL_FEATURES": "Essential features",
  "STANDARD_FEATURES": "Standard features",
  "BUG_FIXES": "Bug fixes",
  "MINOR_BUG_FIXES": "Minor bug fixes.",
  "DONT_SHOW_ESSENTIAL_AGAIN": "Don't show essential features for the current version",
  "DONT_SHOW_ANY_ESSENTIAL_AGAIN": "Don't show essential features for any version",
  "SHOW_ALL_NOTES": "Show notes of all versions",
  "RELEASE_NOTES_SETTINGS_HINT": "These settings are specific to this device only. The settings may be different on another device connected to the same account.",
  "HIDE_CURRENT_ESSENTIAL_HINT": "By checking this option, the new essential features of the current version will no longer be displayed when loading Shizen. We recommend that you check this option if you took the time to read about these.",
  "HIDE_ALL_ESSENTIAL_HINT": "By checing this option, the new essential features about any new version will no longer be displayed when loading Shizen. You should note that a new version is released every 1 or 2 weeks. We recommend that you keep this option unchecked to keep everyone informed about the newest features on this device.",
  versions: [
    {
      version: '2.0.8',
      date: '2022-07-11',
      common: [
        {
          title: `Added plus and minus buttons to indicators during a field tour.`,
          description: `Editing the values will be a lot faster when entering '0' or '1' in the fields.`,
        },
        {
          title: `You can now unselect the leader of an action if you added it by mistake.`,
          description: `Simply click on the same leader again to unselect it.`,
        },
        {
          title: `We enabled emoji in most text fields of Shizen.`,
          description: `Feel free to test it out and tell us what you think.`,
        },
      ],
      bugs: [
        { title: `Fixed indicator edition in some cases when using a calculated indicator.` },
        { title: `Fixed a loading issue with the "text per date" widget.` },
        { title: `Fixed the text area of stickers.` },
        { title: `Fixed loading a chart tooltip in some cases when the tooltip contains a very long text.` },
        { title: `Fixed editing the causes on mobile devices.` },
      ],
    },
    {
      version: '2.0.4',
      date: '2022-06-19',
      common: [
        {
          title: `We recently implemented user roles in Shizen.`,
          description: `Some access can now be restricted per user from the config.`,
        },
      ],
      bugs: [
        { title: `We thank you for taking the time to share the problems you have found related to the new design.<br>The team has addressed most of the issues but we may have missed some!<br>If this is the case, please use the "Report a bug" button in the Shizen menu.` },
      ],
    },
    {
      version: '2.0',
      date: '2022-05-23',
      common: [
        {
          title: `A new design for Shizen 🎁`,
        },
      ],
      bugs: [
      ],
    },
    {
      version: '1.7.49',
      date: '2022-04-25',
      common: [
        {
          title: `Word and excel files can now be previewed from the file edition.`,
          description: `Because of how these files work, some styling features may not appear in the preview.`,
        },
        {
          title: `Problems and actions may now be sorted by archiving dates in the archives.`,
          description: ``,
        },
        {
          title: `Smartphones now feature a single more accessible option to take pictures from the device.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed displaying the meeting navigation inside a slideshow widget.` },
      ],
    },
    {
      version: '1.7.48',
      date: '2022-04-11',
      common: [
        {
          title: `You can now filter problems and actions archives the same way you can filter problems and actions.`,
          description: ``,
        },
        {
          title: `The personnal account page now features a new "@:message.MY_SENT_ACTIONS" tab.`,
          description: ``,
        },
        {
          title: `Problems export now contains information about causes and actions linked to the problems.`,
          description: ``,
        },
        {
          title: `We added a feature to export a completed field tour to an excel format.`,
          description: ``,
        },
        {
          title: `Admins may now export users as an excel file from the config.`,
          description: ``,
        },
        {
          title: `Admins can also disable the modification of completed field tours company-wide.`,
          description: ``,
        },
        {
          title: `Locations and problem types can now be reorganized.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed the display of the date edition on smaller screens.` },
        { title: `Fixed filtering problems using the leader filter.` },
      ],
    },
    {
      version: '1.7.44',
      date: '2022-02-28',
      common: [],
      bugs: [
        { title: `Fixed the display of the "today's value" decimal numbers in indicator wheels.` },
        { title: `Fixed the display of other indicators when changing the value of a calculated indicator.` },
      ],
    },
    {
      version: '1.7.43',
      date: '2022-02-14',
      common: [
        {
          title: `Shizen search will now display up to 100 results for each category.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed an issue causing the trust index of a problem to be stuck at 95%.` },
      ],
    },
    {
      version: '1.7.40',
      date: '2022-01-10',
      common: [
        {
          title: `Global performance improvements.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed displaying weekly/monthly indicators in completed field tours.` },
        { title: `Fixed displaying field tour steps after validating.` },
        { title: `Fixed chart display configuration when using increasing values.` },
        { title: `Fixed the display of the value of a calculated indicator in some cases.` },
      ],
    },
    {
      version: '1.7.39',
      date: '2021-12-20',
      common: [
        {
          title: `Problem stats can now be filtered by location and type.`,
          description: `These filters have also been added to the widgets.`,
        },
        {
          title: `When creating a new indicator, it will automatically be hidden on pages where the entire theme is already hidden.`,
          description: `This saves teams the trouble of changing page settings when a theme should not appear.`,
        },
      ],
      bugs: [
        { title: `Fixed the display of information in notification emails.` },
        { title: `Fixed display of the choice of the leader of a problem.` },
        { title: `Fixed the automatic closing of the assignment of action plans to a team.` },
        { title: `Fixed the display of the problem management page.` },
      ],
    },
    {
      version: '1.7.38',
      date: '2021-12-13',
      common: [
        {
          title: `A weekly/monthly view is now available for the field tour planning compliance table.`,
          description: `The table's columns will now behave according to the selected display configuration. You will see a red dot whenever at least one field tour has not been carried out when it was supposed to be.`,
        },
      ],
      bugs: [
        { title: `Fixed the action leader selection within an action sheet displayed over the problem sheet.` },
      ],
    },
    {
      version: '1.7.37',
      date: '2021-12-06',
      common: [
        {
          title: `Action plans can be reordered from the settings.`,
          description: `The order of your action plan columns will be the same as the order of the plans in the settings.`,
        },
        {
          title: `The name of the author of an information item now appears in the header of the item.`,
          description: ``,
        },
        {
          title: `Information can be created and edited using text formatting features (bold, italic, bullet list, etc.)`,
          description: ``,
        },
        {
          title: `Static and incremental indicators can now be weekly or monthly.`,
          description: ``,
        },
        {
          title: `The problem export now includes the leader of each problem.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed the height of widgets that could appear above the image edition interface.` },
        { title: `Fixed the display of the problem sheet in a slideshow widget.` },
      ],
    },
    {
      version: '1.7.35',
      date: '2021-11-22',
      common: [
        {
          title: `We are introducing the action plan templates into Shizen.`,
          description: `We aim to keep making the creation of new teams even simpler and quicker, keeping the same logic as the meeting and configurable page templates.<br>You may now create new action plans in the config and keep them there as standards, then assign them to teams directly or via startup templates.`,
        },
        {
          title: `You may now add a comment to a single checklist item within a field tour.`,
          description: `Click on the comment icon to the right of the checklist item to display the comments edition window.`,
        },
        {
          title: `We have added a confirmation modal before removing a checklist from a step when editing a field tour.`,
          description: `The modal can be used to cancel the action, or to edit the checklist for example.`,
        },
        {
          title: `The content of the images widgets can now be changed outside the edition mode.`,
          description: `You will first need to enable an option in the widget : "@:message.WIDGET_PICTS_EDITABLE".`,
        },
      ],
      bugs: [
        { title: `Fixed and removed the "Display" item in the dashboard options.` },
        { title: `Fixed and removed the "Edit before starting" button in the field tour list when the option is unavailable.` },
      ],
    },
    {
      version: '1.7.34',
      date: '2021-11-08',
      common: [
        {
          title: `Duplicate your widgets with a single click in the configurable pages.`,
          description: `This new option allows you to create a widget identical to another one. After duplicating a widget, you can change its settings.`,
        },
        {
          title: `A new notification allows you to be alerted when someone comments on a problem that involves your team.`,
          description: `You can also enable emails for this notification from the settings > @:message.SETTINGS_MAIN > @:(message.NOTIFICATIONS).`,
        },
        {
          title: `From the 5-Why and the Ishikawa diagram, you can display the actions related to a cause.`,
          description: `You can also add new actions from the list.`,
        },
      ],
      bugs: [
        { title: `Fixed exporting problems.` },
        { title: `Fixed access to shared problem files.` },
      ],
    },
    {
      version: '1.7.33',
      date: '2021-11-01',
      common: [
        {
          title: `We have improved the calculation field of an indicator in the settings.`,
          description: `You can now type into the field, move the cursor and delete using the "del" and "←" keys.`,
        },
        {
          title: `On informations page, we have replaced the "Managed t." tab with "Sent".`,
          description: `This tab now displays all the information sent by your team.`,
        },
      ],
      bugs: [
        { title: `Fixed a bug when exporting a configurable page as a template.` },
        { title: `Fixed types and locations in the export of the problems list.` },
      ],
    },
    {
      version: '1.7.32',
      date: '2021-10-25',
      essential: [
        {
          title: `You may now ask Shizen to send you email notifications.`,
          description: `You can customize the types of notifications you want to receive from the settings.`,
        },
      ],
      common: [
        {
          title: `You can now display the indicator graphs between the minimum and maximum value.`,
          description: `This setting is available for each indicator individually. Go to the indicator settings, and check the box "@:message.INDIC_SETTINGS_ADAPTATIVE_RANGE".`,
        },
        {
          title: `It is now possible to display the number of the team's pending actions on the navigation menu item.`,
          description: `To do this, you need to customise your menu in the Settings > @:message.SETTINGS_MAIN > @:(message.NAVIGATION_MENU). Create a page for pending actions and from the page settings, check the box "@:(message.DISPLAY_NUMBER_OF_ACTIONS_PENDING)".`,
        },
        {
          title: `We added the option to calculate the average of calculated indicators.`,
          description: `Please note that if the calculation you entered already performs an average (percentage, rate, ...), you should not check this option. This parameter is similar to the calculation of the average for non-calculated indicators as the values will be divided by the number of working days.<br>In the settings of your calculated indicators, if you have activated the "@:message.CALC_AVERAGE" function, a new checkbox will be available: "@:message.SETTINGS_INDIC_AVERAGE_AFTER_CALC".`,
        },
        {
          title: `The text per date widget has a new option to shift the date weekly or monthly.`,
          description: ``,
        },
        {
          title: `We have added the ability to right-click on non-touch devices.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed the cursor position when clicking on a comment field.` },
        { title: `Fixed the possibility to draw with two fingers on non-touch devices.` },
      ],
    },
    {
      version: '1.7.31',
      date: '2021-10-18',
      common: [
        {
          title: `The font size of text widgets can now be automatically adjusted to the size of the widget.`,
          description: `A new option is available on text widgets so that the text size always fits the widget, regardless of its size. This option can particularly be activated when the page is likely to be displayed on smartphones, tablets and large screens.`,
        },
        {
          title: `"Search Shizen" now displays images 20 by 20.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed meeting steps that were advancing 2 by 2.` },
        { title: `Fixed infinite loading when adding a file.` },
        { title: `Fixed display of actions on a detailed indicator page.` },
        { title: `Fixed display of field tour schedules in field tour statistics.` },
      ],
    },
    {
      version: '1.7.29',
      date: '2021-10-11',
      common: [
        {
          title: `When the meeting navigation bar is closed, two new buttons are available to access the next and previous step.`,
          description: `These buttons have the same purpose as the buttons visible on the original bar.`,
        },
        {
          title: `Actions can be changed by leaders even if they are not connected to the team that owns the action.`,
          description: `It was previously necessary to change teams to modify the action.`,
        },
        {
          title: `The team that owns a problem can now modify the PDCAs of other teams' actions.`,
          description: `Previously, only the team responsible for the action could modify the PDCA.`,
        },
        {
          title: `In an action plan, clicking on a filtered action takes you to the action edition page.`,
          description: ``,
        },
        {
          title: `On tablet/smartphone, the full-screen text field will now be focused without the user having to click again.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed synchronization that could stop unexpectedly.` },
        { title: `Fixed display of indicator comments on customisable pages.` },
        { title: `Fixed display of indicator comments on month wheels.` },
        { title: `Fixed editing of text field in text-per-date widget, with slow connection.` },
        { title: `Fixed editing of indicator comment from the slideshow widget on tablet/smartphone.` },
      ],
    },
    {
      version: '1.7.28',
      date: '2021-10-04',
      common: [
        {
          title: `Added a default content option for the new 'text per date' widget.`,
          description: `In the widget options, a new field is now available to fill in the default content of the widget.`,
        },
        {
          title: `It is now possible to create actions from the "5 Whys" and Ishikawa tools.`,
          description: `Actions created in this way will be automatically linked to the causes from which they are added.`,
        },
        {
          title: `The display date in the indicators page can now be set directly from a proper calendar.`,
          description: `The date selected from the calendar is the end date of the range. The start date will be automatically calculated.`,
        },
        {
          title: `Users can now pick postponements reasons from a list of previous postponements.`,
          description: `Start typing in the reason field to filter the list.`,
        },
        {
          title: `Indicators warning messages now appears on doughnuts and charts.`,
          description: `These messages can be set from the indicators settings.`,
        },
        {
          title: `Calculated indicators can now be filled in from the page of a completed field tour.`,
          description: ``,
        },
        {
          title: `We have optimised field tours to make them smoother and more efficient.`,
          description: ``,
        },
        {
          title: `We added the time at the bottom left of the page.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed unexpected keyboard closure on Windows tablets when changing the name of an action.` },
        { title: `Fixed changing the "Objective" field on slow internet connection, in indicators settings.` },
        { title: `Fixed editing the company internal ID from the config.` },
      ],
    },
    {
      version: '1.7.27',
      date: '2021-09-20',
      common: [
        {
          title: `The actions in the problem sheet can now be filtered by PDCA.`,
          description: `To do this, open the blue panel at the top of the action column.`,
        },
        {
          title: `The indicators can be exported in excel format.`,
          description: `The values displayed in the excel file will be those displayed on the page, regardless of the selected configuration.`,
        },
        {
          title: `Field tour participants can now be displayed in the completed field tours page.`,
          description: ``,
        },
        {
          title: `When an action is linked to a problem, the action files will now be available to all teams that have access to the problem.`,
          description: ``,
        },
        {
          title: `The title of configurable pages in the menu can now be changed.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed a bug that prevented a user from logging in after changing teams.` },
        { title: `Fixed a bug preventing the manipulation of stickers located at the bottom left of configurable pages.` },
        { title: `Fixed the assignment of an action to multiple support plans.` },
        { title: `Fixed modification of an indicator comment on mobile.` },
        { title: `Fixed changing period of an indicator in the config.` },
        { title: `Fixed changing the background colour of menu items.` },
      ],
    },
    {
      version: '1.7.24',
      date: '2021-09-13',
      common: [
        {
          title: `Sorting options are now available in the action plans and in the dashboard actions.`,
          description: `These options can be pre-set in the navigation menu settings.`,
        },
        {
          title: `New widget "Text per date".`,
          description: `This widget allows you to share text and save it date by date. It also allows having an history of the passing of instructions.`,
        },
        {
          title: `The name of the user is now displayed in problem sheet history, as well as the name of the person who created the problem.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed a bug affecting the start of a field tour after navigating between several tabs.` },
        { title: `Fixed the calculation of some indicators that could display values when elements of the calculation were missing.` },
        { title: `Fixed display in the history of the problem sheet..` },
      ],
    },
    {
      version: '1.7.23',
      date: '2021-08-30',
      bugs: [
        { title: `Fixed creating a new action.` },
        { title: `Fixed the display of indicator widgets when displaying the comment tooltip.` },
        { title: `Fixed the display of dashboard indicators.` },
        { title: `Fixed navigation arrows for the slideshow widget.` },
      ],
    },
    {
      version: '1.7.22',
      date: '2021-08-23',
      common: [
        {
          title: `The indicators comments can now be formatted with bold, italic, ...`,
          description: `Checklists, bullet lists and other options are also available.`,
        },
        {
          title: `The diaporama widget can now be interacted with.`,
          description: `If you set the diaporama to change pages automatically, you will lose your progress when the page changes.`,
        },
      ],
      bugs: [
        { title: `Fixed the PDCA status that could not be changed in some cases in the action's page.` },
        { title: `Fixed the delete button of checklist items that could be unresponsive.` },
        { title: `Fixed the display of an erroneous modal saying the problem couldn't be edited when changing a problem's files.` },
      ],
    },
    {
      version: '1.7.21',
      date: '2021-07-26',
      bugs: [
        { title: `Fixed manual period selection in indicators page.` },
        { title: `Fixed default indicators template not selected in management indicators.` },
      ],
    },
    {
      version: '1.7.20',
      date: '2021-07-19',
      bugs: [
        { title: `Fixed display in configurable pages when changing the leader of an action or the files of an information.` },
        { title: `Fixed user search in config in some cases.` },
        { title: `Fixed field tour plannings when duplicating field tours.` },
        { title: `Fixed the 'average' setting in calculated indicators.` },
      ],
    },
    {
      version: '1.7.19',
      date: '2021-07-12',
      common: [
        {
          title: `The stats of the field tours are now enhanced with the same period system as the indicators.`,
          requireGW: true,
          description: ``,
        },
        {
          title: `We added a new stat and a new stat widget about whether field tours have been correctly carried out or not.`,
          requireGW: true,
          description: ``,
        },
        {
          title: `Text is now selectable in informations and other places.`,
          description: ``,
        },
        {
          title: `Added support for Chrome 60.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed indicators display in configurable pages and management pages.` },
        { title: `Fixed the floating button in the indicators page.` },
        { title: `Fixed access of a problem's picture if it was added by another team.` },
        { title: `Fixed the numbers of the steps of a meeting.` },
      ],
    },
    {
      version: '1.7.17',
      date: '2021-06-07',
      essential: [
        {
          title: `'Shift' field will soon be removed from indicator widgets.`,
          description: `We now offer a better solution to handle this in the indicators' display configurations. For instance we replaced widgets with a 1-day offset with a new configuration : '@:message.DAILY_INDICATORS_YESTERDAY_VALUE'.<br>You can find out more below in the release notes of version 1.7.15.`,
        },
      ],
      common: [
        {
          title: `We added the user that created the action on the action's page.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Stabilisation of version 1.7.15.` },
        { title: `Fixed the display of indicators in management 'compact' view.` },
        { title: `Fixed the deletion of problem comments.` },
        { title: `Fixed advancing the date of indicators in the indicators page in some cases.` },
        { title: `Fixed the objective of the day in the month view on the dashboard.` },
      ],
    },
    {
      version: '1.7.15',
      date: '2021-05-31',
      essential: [
        {
          title: `You may now define a cause as 'Valid', 'Invalid' or 'Not verified'.`,
          description: `In problem solving, only valid causes should be investigated. After analysing the situation, if a cause has been determined to be invalid, the team does not need to work on it anymore`,
        },
        {
          title: `New option in indicator display configuration allows you to display past week, past month, etc.`,
          description: `We added the option to display dates relatively to the current day. Open a configuration and in '@:message.IDC_END_DATE' section, click '@:message.IDC_CURRENT_DATE_GAP'.<br>For instance, in order to display the past week's values, enter '1 Week'.`,
        },
        {
          title: `Widgets can now be placed and snapped to a grid.`,
          description: `Two snapping modes for widgets: To each other or to a grid.`,
        },
      ],
      common: [
        {
          title: `Added the 'Underline' function and a feature to paste hyperlinks in the comments field of an action.`,
          description: `URL links may now be copy-pasted in the field.`,
        },
        {
          title: `Added an archive/restore button in the problem sheet's right panel.`,
          description: ``,
        },
        {
          title: `Problem state 'Resolution complete' becomes 'Actions completed'.`,
          description: ``,
        },
        {
          title: `Problem state 'Ongoing actions' will be effective once an action has started.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed displaying widgets panel in configurable pages.` },
        { title: `Fixed actions progress in action plans when the device has a sligth time offset.` },
        { title: `Fixed displaying indicator comments after ticking '@:message.INDIC_SETTINGS_DISPLAY_CALC_COMMENTS'.` },
      ],
    },
    {
      version: '1.7.14',
      date: '2021-05-24',
      common: [
        {
          title: `'Coments' field of an action is now enhanced with a few formatting features, such as bold, italic, checklists, bullet lists, ...`,
          description: ``,
        },
        {
          title: `You will find a few new options on the stats page, such as displaying values on charts or filtering problems stats.`,
          description: ``,
        },
        {
          title: `You may now enter an email address and a phone number when reporting a bug to Shizen.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed displaying user manuals.` },
      ],
    },
    {
      version: '1.7.13',
      date: '2021-05-17',
      common: [
        {
          title: `We added an option to display specific action plans in the actions page.`,
          description: ``,
        },
        {
          title: `The behaviour of actions and problems postponements is now more accurate.`,
          description: ``,
        },
        {
          title: `The layout of the dashboard has been slightly improved regarding indicators.`,
          description: ``,
        },
        {
          title: `A user manual is now available in most pages of Shizen.`,
          description: ``,
        },
        {
          title: `You may now paste an image from your clipboard when importing a file to a problem, an action or an information.`,
          description: ``,
        },
        {
          title: `The number of teams and users is now available in the config.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed a bug that could happen when importing a classic indicator into a field tour theme.` },
        { title: `Fixed a bug where an admin could delete itself from the config.` },
      ],
    },
    {
      version: '1.7.9',
      date: '2021-04-12',
      common: [
        {
          title: `We added the 'fixed end date' feature for indicator display configurations.`,
          description: ``,
        },
        {
          title: `By the way, the indicator display configurations can now be edited from the settings when changing the options of a page.`,
          description: ``,
        },
        {
          title: `We reduced the size of the 'bug' button at the bottom of the page fro small devices.`,
          description: ``,
        },
        {
          title: `We removed the field tour indicators from the 'hide indicators' option.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed a bug during a field tour where the step duration could appear wrong.` },
        { title: `Fixed a bug that would prevent editing user details in some cases.` },
        { title: `Fixed a bug where save buttons could appear at the wrong place on the problem creation page.` },
        { title: `Fixed a bug that could prevent the first value of some indicators to be displayed in management indicators.` },
      ],
    },
    {
      version: '1.7.8',
      date: '2021-04-05',
      common: [
        {
          title: `When editing an indicator of another team, its name is now displayed.`,
          description: ``,
        },
        {
          title: `Informations may now be sent to any other team if the admin enable it.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed the indicator comment text field in field tours.` },
        { title: `Fixed the zones settings of the problems page in meeting steps.` },
        { title: `Fixed a bug that could duplicate the navigation items in the menu.` },
      ],
    },
    {
      version: '1.7.7',
      date: '2021-03-29',
      common: [
        {
          title: `We added a stat about the number of action postponements in the stats page.`,
          description: ``,
        },
      ],
    },
    {
      version: '1.7.6',
      date: '2021-03-22',
      common: [
        {
          title: `You can create meetings for multiple teams from the config.`,
          description: ``,
        },
        {
          title: `We have removed the 'save' button in the meetings settings.`,
          description: ``,
        },
        {
          title: `You may now set the default display for management indicators page in the menu settings.`,
          description: ``,
        },
        {
          title: `In calculated indicators, we have replaced the missing values with 0, when possible.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed a problem for text areas on Firefox.` },
        { title: `Fixed a problem where an indicator could not be re-ordered.` },
        { title: `Fixed a bug that could prevent adding images or documents to a widget.` },
        { title: `Fixed a problem that could erase some entered text for indicators comments.` },
      ],
    },
    {
      version: '1.7.5',
      date: '2021-03-15',
      common: [
        {
          title: `Configurable pages can be standardized accross the company.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed a problem where actions would disappear when editing a problem sheet.` },
        { title: `Fixed the size of the comment area when editing an indicator.` },
        { title: `Fixed a bug that could prevent sending an action or a problem to a team.` },
        { title: `Fixed a bug that could prevent data from being displayed in the completed field tours page.` },
        { title: `Fixed the number of hidden indicators on indicators pages.` },
      ],
    },
    {
      version: '1.7.4',
      date: '2021-03-08',
      essential: [
        {
          requireGW: true,
          title: `We simplified the setup of field tours.`,
          description: `Checklists can now be created and modified from the field tour edition page. Checklists and field tour indicators will be autmatically duplicated upon duplicating a field tour.`,
        },
      ],
      common: [
        {
          title: `Calculated indicators may now display the comments of the indicators used in the calculation instead of the usual comments.`,
          description: ``,
        },
        {
          title: `You may now use other teams indicators to create a calculated indicator.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed a problem when using '+' and '-' buttons in indicator edition.` },
        { title: `Fixed an issue that could prevent using a calculated indicator properly.` },
      ],
    },
    {
      version: '1.7.0',
      date: '2021-02-08',
      essential: [
        {
          requireGW: true,
          title: `Field tour indicators improvements.`,
          description: `We are bringing new features to the field tour indicators.<br><br>\
From now on, field tour indicators will behave just as classic indicators do. As such, we moved those indicators to the main indicators settings.<br><br>\
You may now have a look at your indicators just like classic indicators. Field tour indicators are hidden by default on indicators pages but you can display them from widgets in configurable pages, and they can now be computed by calculated indicators.
Note that next updates will make it easier to setup and carry out field tours.`,
        },
      ],
      common: [
      ],
    },
    {
      version: '1.6.8',
      date: '2021-01-25',
      common: [
        {
          title: `Missing field tours are back again in the list of completed field tours.`,
          description: ``,
        },
        {
          title: `Informationscan now be sent to all accessible teams.`,
          description: ``,
        },
        {
          title: `More information available about the issues you reported to Shizen, such as pictures and comments if any.`,
          description: ``,
        },
      ],
    },
    {
      version: '1.6.7',
      date: '2021-01-11',
      common: [
        {
          title: `The field tours templates are now broken down by team.`,
          description: `You can still find the field tours of the other teams from the options of the page.`,
        },
      ],
    },
    {
      version: '1.6.6',
      date: '2021-01-04',
      common: [
        {
          title: `The teams organisational chart can be customisedfrom the administration panel.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Fixed a bug that could prevent seeing values of public incremental indicators.` },
        { title: `Fixed configurable pages minor issues.` },
        { title: `Fixed an error that could happen when starting a meeting with a locked user account.` },
      ],
    },
    {
      version: '1.6.5',
      date: '2020-12-21',
      common: [
        {
          title: `More information have been added in the field tour information.`,
          description: ``,
        },
        {
          title: `Sharing a problem has been moved to the 'Problem' section in the problem sheet.`,
          description: ``,
        },
        {
          title: `Order of the history in the problem sheet has been reversed.`,
          description: ``,
        },
      ],
      bugs: [
        { title: 'Fixed display issues in settings' },
        { title: 'Fixed display issue in completed field tours' },
        { title: 'Fixed emailing issue in the configuration panel' },
      ],
    },
    {
      version: '1.6.4',
      date: '2020-12-07',
      common: [
        {
          title: `You may set up to three characters for indicator themes.`,
          description: ``,
        },
        {
          title: `Added a button to display a window to edit all the details of an action from the problem sheet.`,
          description: ``,
        },
        {
          title: `Stickers can display line breaks properly.`,
          description: ``,
        },
        {
          title: `Added SAML compatibility for Google SSO.`,
          description: ``,
        },
      ],
    },
    {
      version: '1.6.3',
      date: '2020-11-30',
      common: [
        {
          title: `You may now change the default home page.`,
          description: `If the dashboard doesn't suit your specific needs, you can change the default home page from the @:message.SETTINGS > @:message.SETTINGS_MAIN > @:(message.DEFAULT_HOME_PAGE). Note that you can still use the dashboard if you change the default home page.`,
        },
        {
          title: `You may now link an action to an indicator of the team.`,
          description: `You can do so from the action edition page. Additionnally, if a problem is linked to some indicators, all new actions created from this problem will be linked to the same indicators.`,
        },
        {
          title: `The name of the person who carried out a field tour is now displayed in the completed field tours list.`,
          description: `The person who carried out the field tour must be connected to his/her personnal user account.`,
        },
        {
          title: `Default end date for an information has been changed to the day after the information release.`,
          description: `It used to be a week after the release.`,
        },
      ],
      bugs: [
        { title: `Fixed an issue where indicator objectives could not be edited.` },
        { title: `Securing actions can no longer be added to action plans.` },
      ],
    },
    {
      version: '1.6.1',
      date: '2020-11-16',
      common: [
        {
          beta: `@:message.BETA_SSO_LOGIN.`,
          title: `Login through SSO is now available.`,
          description: `Once the administrators of your Shizen account have set it up, you will be able to login to Shizen by selecting the '@:message.LOGIN_BY_SSO' option from the login page.`,
        },
      ],
    },
    {
      version: '1.6.0',
      date: '2020-11-09',
      common: [
        {
          title: `Individual user account login is now available.`,
          description: `Once the administrators of your Shizen account have set up your user account, you will receive an email containing a username and a new temporary password. You will then be able to login to Shizen by selecting the '@:message.LOGIN_BY_USER' option from the login page.`,
        },
        {
          title: `Field tour checklists loading has been greatly improved.`,
          description: `Loading could take some time when trying to visualize a lot of checklists at a time.`,
        },
      ],
      bugs: [
        { title: `Fixed a display issue in action items in detailed indicator and configurable pages.` },
      ],
    },
    {
      version: '1.5.5',
      date: '2020-10-19',
      common: [
        {
          title: `Public indicators will now refresh properly after a value is changed.`,
          description: '',
        },
        {
          title: `Search is now more accurate.`,
          description: '',
        },
        {
          title: `Charts for cumulated indicators can now be displayed as bar charts.`,
          description: '',
        },
        {
          title: `The pop-up message has been removed when clicking an indicator value with no comments.`,
          description: '',
        },
      ],
      bugs: [
        { title: `Fixed incremental indicators not working after a new value is set.` },
        { title: `Fixed navigation menu items overlapping with the page.` },
        { title: `Search bar has been removed on smartphones.` },
      ],
    },
    {
      version: '1.5.4',
      date: '2020-10-12',
      common: [
        {
          title: `Information items can now be sorted as you see fit.`,
          description: '',
        },
      ],
      bugs: [
        { title: `Fixed stickers edition on some devices.` },
        { title: `Fixed indicators tooltips display.` },
        { title: `Fixed indicators display when showing an 'infinite' value.` },
        { title: `Fixed the objective of public indicators in specific cases.` },
        { title: `Fixed number of completed problems in stats.` },
      ],
    },
    {
      version: '1.5.3',
      date: '2020-10-05',
      common: [
        { title: `You may now click on chart points or chart tooltips to enlarge the content of the tooltip.` },
      ],
      bugs: [
        { title: `Fixed edition of ishikawa causes on mobile devices.` },
      ],
    },
    {
      version: '1.5.2',
      date: '2020-09-28',
      common: [
        {
          title: `Add hints below the impact slider in the problem sheet and problem reporting.`,
          description: `@:message.SETTINGS > @:message.SETTINGS_PROBLEMS > @:message.CUSTOM_PROBLEM_HINTS.`,
        },
        {
          title: `New settings available for the 'Management > Indicators' page in the navigation menu.`,
          description: `You can now set the default view and the selected teams from @:message.SETTINGS > @:message.SETTINGS_MAIN > @:message.NAVIGATION_MENU.`,
        },
        {
          title: `Overall performance improvements.`,
          description: '',
        },
      ],
      bugs: [
        { title: `Fixed wrong number of ongoing and completed problems in stats.` },
        { title: `Fixed an issue when using the 'average' setting on a public indicator.` },
      ],
    },
    {
      version: '1.5.1',
      date: '2020-09-21',
      essential: [
        {
          title: `Problem reporting hints can be customized.`,
          description: ``,
        },
      ],
      common: [
        {
          title: `Added icon on cause items to un-select the cause more easily.`,
          description: ``,
        },
        {
          title: `Color circles in management indicators 'compact' view are now pie chart.`,
          description: `Each circle now displays the breakdown of OK, NOK and empty values.`,
        },
      ],
      bugs: [
        { title: `Fixed increasing indicator displaying showing '0' instead of empty values.` },
        { title: `Fixed indicator calculation not working properly with some public indicators.` },
        { title: `Fixed some display issues on the dashboard and indicators pages.` },
      ],
    },
    {
      version: '1.5.0',
      date: '2020-09-14',
      essential: [
        {
          beta: `@:message.BETA_CALCULATED_INDIC.`,
          title: `Create calculated indicators ! 💹.`,
          description: `Beta calculated indicators have just been released. Feel free to try it out from indicators settings.`,
        },
      ],
      common: [
        {
          title: `Line breaks in action comments edition.`,
          description: ``,
        },
      ],
      bugs: [
        {
          title: `Fixed the language of the date edition modal.`,
        },
      ],
    },
    {
      version: '1.4.2',
      date: '2020-09-06',
      bugs: [
        {
          title: `Fixed compactindicators display.`,
        },
        {
          title: `Fixed display issues in action plans and indicator charts.`,
        },
      ],
    },
    {
      version: '1.4.0',
      date: '2020-06-29',
      essential: [
        {
          title: `Securing actions can now be displayed within the ongoing actions page.`,
          description: '',
        },
        {
          title: `Indicator widgets can now be used to display cumulated values as the detailed indicator widget.`,
          description: '',
        },
        {
          title: `The indicators loading performance has been improved and a loading logo will now be displayed every time Shizen updates indicator values.`,
          description: '',
        },
      ],
      common: [
        {
          title: `Information can now be edited from the Dashboard.`,
          description: '',
        },
        {
          title: `Static and incremental indicator values may now be deleted.`,
          description: '',
        },
      ],
      bugs: [
        {
          title: `Fixed the display of the comment circle on indicator charts.`,
        },
        {
          title: `Fixed inconsistent period in indicator widgets when using custom indicator configurations.`,
        },
        {
          title: `Fixed inconsistent sorting in completed field tours.`,
        },
        {
          title: `Fixed objective display in detailed indicator.`,
        },
        {
          title: `Fixed schedule: Page could show events at the wrong date.`,
        },
      ],
    },
    {
      version: '1.3.64',
      date: '2020-06-22',
      common: [
        {
          title: 'New indicator chart options : Period and values',
          description: 'Feel free to test this feature by visiting @:message.SETTINGS > @:message.SETTINGS_INDICATORS > @:message.INDIC_SETTINGS_CHARTS_DISPLAY',
        },
      ],
    },
    {
      version: '1.3.60',
      date: '2020-06-01',
      common: [
        {
          title: 'Warning message in detailed indicator pages to encourage users to report problems when indicators exceed the objective',
          description: 'This feature can be turned off from @:message.SETTINGS > @:message.SETTINGS_INDICATORS > @:message.DISPLAY_NEO_HINTS',
        },
        {
          title: 'Added types and locations in similar problems search',
          description: '',
        },
        {
          title: 'Added recurrence pareto chart in the stats page',
          description: '',
        },
      ],
      bugs: [
        {
          title: 'Fixed display issues in the indicators page.',
          description: ''
        },
        {
          title: 'Fixed a bug which caused chart to display the wrong objective on the indicators page.',
          description: ''
        },
        {
          title: '@:message.DETAILED_INDICATOR : Fixed the widget in configurable pages.',
          description: ''
        },
        {
          title: '@:message.DETAILED_INDICATOR : Fixed the offset between the values focused in the top chart and the values displayed in the bottom chart.',
          description: ''
        },
      ]
    },
    {
      "version": "1.3.57",
      "date": "2020-05-18",
      "common": [
        {
          "title": "Proper assignment history in the action sheet",
          "description": ""
        }
      ]
    },
    {
      "version": "1.3.56",
      "date": "2020-05-11",
      "common": [
        {
          "title": "Display problems impact on indicator charts",
          "description": "@:(message.INDIC_SETTINGS_DISPLAY_PROBLEMS_IMPACT_HINT). Go to Settings > @:message.SETTINGS_INDICATORS > @:message.INDIC_SETTINGS_DISPLAY_PROBLEMS_IMPACT"
        },
        {
          "title": "Pictures widget is now compatible with additionnal formats (.gif, .pdf, ...)",
          "description": ""
        }
      ]
    },
    {
      "version": "1.3.55",
      "date": "2020-05-04",
      "essential": [
        {
          "title": "Choose which indicators to display and hide in the indicators page",
          "description": "Choose this on the fly by clicking the bottom right button on the indicators page and choosing '@:message.HIDE_SOME_INDICATORS'. You may also setup pages in the menu. For instance, to set up a long-term indicators page:<ul><li>Go to settings > @:message.SETTINGS_MAIN > @:(message.NAVIGATION_MENU).</li><li>Click '@:message.ADD_A_LINK' at the bottom and pick the indicators page.</li><li>Click '@:message.CHOOSE_SETTINGS' and check the indicators that you don't want to display in the long-term page.</li><li>You may also pick a long-term configuration by clicking '@:message.IDC_CHART'</li></ul>Feel free to use the same procedure for meeting steps."
        }
      ],
      "common": [
        {
          "title": "Existing actions can now be assigned to a problem",
          "description": ""
        },
        {
          "title": "Added releases dates in release notes window",
          "description": ""
        },
        {
          "title": "Release notes can be displayed from the notifications panel",
          "description": ""
        },
        {
          "title": "Datepicker calendars now use monday as the first day of the week when using French language",
          "description": ""
        },
        {
          "title": "Problems creation date can be edited",
          "description": ""
        }
      ],
      "bugs": [
        {
          "title": "Fixed display of Indicators page options in meetings steps settings"
        }
      ]
    },
    {
      "version": "1.3.54",
      "date": "2020-04-27",
      "essential": [
        {
          "title": "Release notes and information",
          "description": "You may now use this window to see the content of the updates. Click on '@:release.SHOW_ALL_NOTES' to access more information about the latest updates. In addition, if you have decided to hide this window, you will find this information in the settings > @:message.SETTINGS_MAIN > @:release.RELEASE_NOTES"
        }
      ],
      "common": [
        {
          "title": "Added 'location' field in advanced problem reporting",
          "description": ""
        },
        {
          "title": "'S' and 'A' letters for sent actions and problems have been replaced with an icon",
          "description": ""
        }
      ],
      "bugs": [
        {
          "title": "Some actions wouldn't appear in archives after being completed"
        }
      ]
    },
    {
      "version": "1.3.53",
      "date": "2020-04-20",
      "essential": [
        {
          "title": "Indicator objectives editable from indicator input",
          "description": ""
        }
      ],
      "common": [
        {
          "title": "Similar problems loading improvment",
          "description": ""
        },
        {
          "title": "New icon for late actions",
          "description": ""
        }
      ],
      "bugs": [
        {
          "title": "Neo display bug fixes in problem sheets and indicators page"
        }
      ]
    },
    {
      "version": "1.3.50",
      "date": "2020-04-06",
      "common": [
        {
          "title": "Action leader name displayed in support action plans"
        },
        {
          "title": "New 'Problem saved' message when editing a problem sheet"
        }
      ],
      "bugs": [
        {
          "title": "Fixed indicator comments bubble on indicator charts"
        },
        {
          "title": "Fixed causes content height in problem sheets and five whys"
        }
      ]
    }
  ]
}

export default release;
